import React from "react";

import { Box, Container, Link, Stack, Typography } from "@mui/material";
import {
  getColorWithMode,
  getAccent,
  HEADING_FONT,
} from "../constants/colors";
import GearComparisonSelectorCollapse from "./GearComparisonSelectorCollapse";
import { getUserIsLoggedIn } from "../utils";
import { Backpack, ChevronDown, Compass, Store } from "lucide-react";

const SubNavBar = ({ darkMode }) => {
  const [browseGearIsOpen, setBrowseGearIsOpen] = React.useState(true);
  return (
    <Container
      sx={{
        height: "50px",
        position: "sticky",
        top: "50px",
        zIndex: 100,
        padding: "0px 0px 0px 0px",
        backgroundColor: getColorWithMode(darkMode, "nav"),
        borderBottom: `0.5px solid ${getColorWithMode(darkMode, "navBottom")}`,
      }}
    >
      <Stack direction="row">
        <Link href="/packs" sx={{ textDecoration: "none" }}>
          <Box
            sx={{
              height: "50px",
              width: "140px",
              textAlign: "center",
              color: getColorWithMode(darkMode, "text"),
              "&:hover": {
                color: getAccent(darkMode),
                backgroundColor: darkMode
                  ? "rgba(144,202,249,0.08)"
                  : "rgba(25,118,210,0.05)",
                cursor: "pointer",
              },
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              gap={1}
              sx={{
                height: "100%",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Backpack size={18} />
              <Typography
                sx={{
                  fontFamily: HEADING_FONT,
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                {getUserIsLoggedIn() ? "My Packs" : "Create"}
              </Typography>
            </Stack>
          </Box>
        </Link>
        <Link href="/browse" sx={{ textDecoration: "none" }}>
          <Box
            sx={{
              height: "50px",
              width: "180px",
              textAlign: "center",
              color: getColorWithMode(darkMode, "text"),
              "&:hover": {
                color: getAccent(darkMode),
                backgroundColor: darkMode
                  ? "rgba(144,202,249,0.08)"
                  : "rgba(25,118,210,0.05)",
                cursor: "pointer",
              },
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              gap={1}
              sx={{
                height: "100%",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Compass size={16} />
              <Typography
                sx={{
                  fontFamily: HEADING_FONT,
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                Browse Packs
              </Typography>
            </Stack>
          </Box>
        </Link>
        <Box
          sx={{
            height: "50px",
            width: "200px",
            textAlign: "center",
            verticalAlign: "center",
            lineHeight: "50px",
            color: getColorWithMode(darkMode, "text"),
            "&:hover": {
              color: getAccent(darkMode),
              backgroundColor: darkMode
                ? "rgba(144,202,249,0.08)"
                : "rgba(25,118,210,0.05)",
              cursor: "pointer",
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            setBrowseGearIsOpen(!browseGearIsOpen);
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            gap={1}
            sx={{
              height: "100%",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Store size={16} />
            <Typography
              sx={{
                fontFamily: HEADING_FONT,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              Explore Gear
            </Typography>
            <ChevronDown size={18} />
          </Stack>
        </Box>
      </Stack>
      <GearComparisonSelectorCollapse
        darkMode={darkMode}
        browseGearIsOpen={browseGearIsOpen}
        setBrowseGearIsClosed={setBrowseGearIsOpen}
      />
    </Container>
  );
};

export default SubNavBar;
